import { DidNotPerformReasonEnum, InterventionTypeEnum, type InterventionTaskViewModel } from '@generated';
import Yup from '~/util/yup';
import { generateValidationSchema } from '~/libraries/forms/validation';

export function getInterventionDocumentationValidationSchema(interventionTask: InterventionTaskViewModel): Yup.AnyObjectSchema {
	return Yup.object().shape({
		...(interventionTask.interventionDefinition && interventionTask.interventionDefinition.documentationFormFields
			? generateValidationSchema(interventionTask.interventionDefinition.documentationFormFields)
			: {}),
		patientToleratedId:
			interventionTask.interventionTypeId === InterventionTypeEnum.Perform
				? Yup.string().label('Patient Tolerated').nullable().required()
				: Yup.string().label('Patient Tolerated').nullable(),
		performedById: Yup.string()
			.label('Performed By')
			.nullable()
			.when('markAsNotPerformed', {
				is: true,
				then: schema => schema,
				otherwise: schema => schema.required()
			}),
		performedOn: Yup.date()
			.label('Performed On')
			.nullable()
			.when('markAsNotPerformed', {
				is: true,
				then: schema => schema,
				otherwise: schema => schema.required()
			}),
		instructionTargetPatient: Yup.bool().label('Patient Instructed'),
		instructionTargetCaregiver: Yup.bool().label('Caregiver Instructed'),
		instructionTargetOther: Yup.string().nullable().label('Other Instructed'),
		instructionResponseId:
			interventionTask.interventionTypeId === InterventionTypeEnum.Instruct
				? Yup.string().label('Instruction Response').required()
				: Yup.string().label('Instruction Response').nullable()
	});
}

export function getDidNotPerformValidationSchema(): Yup.AnyObjectSchema {
	return Yup.object().shape({
		didNotPerformReasonId: Yup.string().label('Did Not Perform Reason').nullable().required(),
		didNotPerformReasonOther: Yup.string()
			.label('Other')
			.when(`didNotPerformReasonId`, {
				is: (val: string) => val && Number(val) === DidNotPerformReasonEnum.Other,
				then: schema => schema.required(),
				otherwise: schema => schema.nullable()
			})
	});
}
